import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import ContactListSaga from "./contacts-lists/saga";
import UsersListSaga from "./account/saga";
import BulkListSaga from "./bulk-lists/saga";
import ScheduledSaga from "./scheduled/saga";
import dashboardSaga from "./dashboard/saga";
import dashboardBlogSaga from "./dashboard-blog/saga";
import ConfigSaga from "./config/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(dashboardBlogSaga),
    fork(ContactListSaga),
    fork(UsersListSaga),
    fork(BulkListSaga),
    fork(ScheduledSaga),
    fork(ConfigSaga),
  ]);
}
